import React, { Component } from 'react';
import BoneIcon1 from '../../img/boneIcon-01.png'

class FavouriteDog extends Component {

	render(){

		return (
			
			<React.Fragment>
			
				<div className="profile-card" style={{paddingTop: 15}}>
				<img alt="dog profile" id="avatar-tab" className="float-left" src={BoneIcon1}/>
					<img alt="dog profile" id="avatar-tab" className="float-left" src={this.props.avatar}/>
							<p  style={{marginLeft: 120, fontSize: 30}} id="dog-name">{this.props.name}</p>						
				</div>
			</React.Fragment>

				
			);
	
	};
}




export default FavouriteDog;